import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withKeys as _withKeys, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "user-picker-body"
};
const _hoisted_2 = {
  key: 0,
  class: "user-selected-panel"
};
const _hoisted_3 = {
  class: "user-selected-header"
};
const _hoisted_4 = {
  class: "user-selected-title"
};
const _hoisted_5 = {
  class: "user-selected-list"
};
const _hoisted_6 = ["title"];
const _hoisted_7 = {
  class: "user-chip-avatar"
};
const _hoisted_8 = ["src", "alt"];
const _hoisted_9 = {
  key: 1
};
const _hoisted_10 = {
  class: "user-chip-name"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = ["title"];
const _hoisted_13 = {
  class: "user-search"
};
const _hoisted_14 = {
  key: 1,
  class: "user-selectall-bar"
};
const _hoisted_15 = ["disabled"];
const _hoisted_16 = {
  key: 0,
  class: "user-selectall-total"
};
const _hoisted_17 = ["onClick"];
const _hoisted_18 = {
  class: "user-row-main"
};
const _hoisted_19 = ["src", "alt"];
const _hoisted_20 = {
  key: 1,
  class: "user-avatar-char"
};
const _hoisted_21 = {
  class: "user-meta"
};
const _hoisted_22 = {
  class: "user-name"
};
const _hoisted_23 = {
  key: 0,
  class: "user-username"
};
const _hoisted_24 = {
  key: 0,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor"
};
const _hoisted_25 = {
  key: 0,
  class: "load-hint"
};
const _hoisted_26 = {
  key: 1,
  class: "load-hint"
};
const _hoisted_27 = {
  class: "user-picker-footer"
};
const _hoisted_28 = {
  class: "user-footer-info"
};
const _hoisted_29 = {
  class: "user-footer-actions"
};
import { ref, reactive, computed } from 'vue';
import { ElMessage } from 'element-plus';
import { Search } from '@element-plus/icons-vue';
import { useVModel } from '@vueuse/core';
import { getList } from '@/api/modules/user';
import { getUser, listUsersByIds } from '@/api/user';
const SELECTED_DISPLAY_LIMIT = 50;
export default {
  __name: 'UserPicker',
  props: {
    modelValue: {
      type: [Number, String, Array],
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    },
    maxSelect: {
      type: Number,
      default: null
    },
    excludeIds: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue', 'confirm'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const $props = __props;
    const $emits = __emit;
    const value = useVModel($props, 'modelValue', $emits);
    const userOptions = ref([]);
    const userList = ref([]);
    const loading = ref(false);
    const scrollbarRef = ref();
    const hasMore = ref(true);
    const pagination = reactive({
      page: 1,
      size: 10,
      total: 0
    });
    const toUserOption = user => {
      const data = user?.data || user || {};
      return {
        id: data.id,
        name: data.displayName || data.name || data.username || String(data.id),
        type: 'user',
        leaf: true,
        avatar: data.avatarUrl || data.avatar,
        username: data.username
      };
    };

    // 已选 id 集合（Set 缓存，保证大选中量下列表行的选中判断为 O(1)）
    const selectedIdSet = computed(() => new Set(userOptions.value.map(e => String(e.id))));
    const isSelected = user => {
      return selectedIdSet.value.has(String(user.id));
    };
    const onUserClick = data => {
      if ($props.multiple) {
        const index = userOptions.value.findIndex(e => String(e.id) === String(data.id));
        if (index === -1) {
          if ($props.maxSelect && userOptions.value.length >= $props.maxSelect) {
            ElMessage.warning(`最多选择${$props.maxSelect}人`);
            return;
          }
          userOptions.value.push(data);
          userOptions.value.sort((a, b) => String(a.id).localeCompare(String(b.id)));
        } else {
          userOptions.value.splice(index, 1);
        }
      } else {
        const index = userOptions.value.findIndex(e => String(e.id) === String(data.id));
        if (index === -1) {
          userOptions.value = [data];
        } else {
          userOptions.value.splice(index, 1);
        }
      }
    };
    // 全选相关
    const selectAllLoading = ref(false);

    // 仅当已加载完当前筛选条件下的全部用户且全部被选中时，才视为"已全选"
    const isAllSelected = computed(() => {
      if (!$props.multiple) return false;
      if (hasMore.value) return false;
      if (visibleUserList.value.length === 0) return false;
      return visibleUserList.value.every(user => isSelected(user));
    });
    const toggleSelectAll = async () => {
      if (selectAllLoading.value) return;
      // 取消全选：仅移除当前可见列表中的用户，不影响其他搜索条件下已选的用户
      if (isAllSelected.value) {
        const visibleIds = new Set(visibleUserList.value.map(user => String(user.id)));
        userOptions.value = userOptions.value.filter(user => !visibleIds.has(String(user.id)));
        return;
      }
      selectAllLoading.value = true;
      try {
        // 尚未加载完时，按当前搜索条件一次性拉取全部用户（走轻量 simpleList 接口）
        if (hasMore.value) {
          const keyword = queryForm.name?.trim();
          const res = await getList({
            page: 1,
            size: Math.max(pagination.total, pagination.size, 1),
            username: keyword || undefined
          });
          if (res.success) {
            const records = res.data?.records || res.data || [];
            userList.value = records.map(toUserOption);
            pagination.page = 1;
            pagination.total = Number(res.total ?? records.length);
            hasMore.value = false;
          }
        }
        const selectedIds = new Set(userOptions.value.map(user => String(user.id)));
        let candidates = visibleUserList.value.filter(user => !selectedIds.has(String(user.id)));
        if (candidates.length === 0) return;
        if ($props.maxSelect) {
          const capacity = Math.max($props.maxSelect - userOptions.value.length, 0);
          if (candidates.length > capacity) {
            candidates = candidates.slice(0, capacity);
            ElMessage.warning(`最多选择${$props.maxSelect}人`);
          }
        }
        userOptions.value = [...userOptions.value, ...candidates];
        userOptions.value.sort((a, b) => String(a.id).localeCompare(String(b.id)));
      } finally {
        selectAllLoading.value = false;
      }
    };

    // 已选区折叠展示，防止全选大量用户后渲染卡顿
    const displayedSelectedUsers = computed(() => userOptions.value.slice(0, SELECTED_DISPLAY_LIMIT));
    const hiddenSelectedUsers = computed(() => userOptions.value.slice(SELECTED_DISPLAY_LIMIT));
    const hiddenSelectedNames = computed(() => {
      const names = hiddenSelectedUsers.value.map(user => user.name || user.id).filter(Boolean);
      const text = names.slice(0, 50).join('、');
      return names.length > 50 ? `${text}…` : text;
    });
    const dialogVisible = ref(false);
    const queryForm = reactive({
      name: ''
    });
    const open = () => {
      dialogVisible.value = true;
    };
    const fetchUsers = async ({
      append = false
    } = {}) => {
      if (loading.value) return;
      loading.value = true;
      try {
        const keyword = queryForm.name?.trim();
        const res = await getList({
          page: pagination.page,
          size: pagination.size,
          username: keyword || undefined
        });
        if (res.success) {
          const records = res.data?.records || res.data || [];
          const nextUsers = records.map(toUserOption);
          if (append) {
            const exists = new Set(userList.value.map(user => String(user.id)));
            userList.value = userList.value.concat(nextUsers.filter(user => !exists.has(String(user.id))));
          } else {
            userList.value = nextUsers;
          }
          pagination.total = Number(res.total ?? res.data?.total ?? records.length);
          hasMore.value = pagination.total > 0 ? userList.value.length < pagination.total : records.length === pagination.size;
        }
      } finally {
        loading.value = false;
      }
    };
    const chunkIds = (arr, size) => {
      const chunks = [];
      for (let i = 0; i < arr.length; i += size) {
        chunks.push(arr.slice(i, i + size));
      }
      return chunks;
    };
    const toPlaceholderUser = id => ({
      id,
      name: String(id),
      type: 'user',
      leaf: true,
      avatar: '',
      username: ''
    });
    const loadSelectedUsers = async () => {
      // 处理已选中的用户ID，查找并填充用户信息
      let userIds = [];
      if (Array.isArray(value.value)) {
        userIds.push(...value.value);
      } else if (value.value) {
        userIds.push(value.value);
      }
      userIds = userIds.map(id => id && typeof id === 'object' ? id.id : id).filter(id => id !== null && id !== undefined && id !== '');
      if (userIds.length === 0) {
        userOptions.value = [];
        return;
      }

      // 优先复用已加载列表中的用户，其余走批量接口（分批并发，避免超长 IN 列表）
      const resolved = new Map();
      userIds.forEach(id => {
        const currentPageUser = userList.value.find(u => String(u.id) === String(id));
        if (currentPageUser) resolved.set(String(id), {
          ...currentPageUser
        });
      });
      const missingIds = userIds.filter(id => !resolved.has(String(id)));
      if (missingIds.length > 0) {
        let users = [];
        try {
          const responses = await Promise.all(chunkIds(missingIds, 500).map(ids => listUsersByIds(ids)));
          users = responses.flat().filter(Boolean).map(toUserOption);
        } catch (error) {
          console.error('批量加载用户信息失败，降级为逐个加载:', error);
          users = await Promise.all(missingIds.map(async id => {
            try {
              return toUserOption(await getUser(id));
            } catch (e) {
              console.error('加载用户信息失败:', e);
              return toPlaceholderUser(id);
            }
          }));
        }
        users.forEach(user => {
          if (user && user.id !== null && user.id !== undefined) {
            resolved.set(String(user.id), user);
          }
        });
      }

      // 保持传入 id 顺序；批量接口未返回的用户（已删除/跨租户）用占位信息，与旧行为一致
      const selected = userIds.map(id => resolved.get(String(id)) || toPlaceholderUser(id));
      userOptions.value = selected.filter(user => user.id);
    };
    const onOpen = async () => {
      pagination.page = 1;
      hasMore.value = true;
      userList.value = [];
      await fetchUsers();
      await loadSelectedUsers();
    };
    const handleSearch = () => {
      pagination.page = 1;
      hasMore.value = true;
      userList.value = [];
      fetchUsers();
    };
    const excludeIdSet = computed(() => new Set(($props.excludeIds || []).map(id => String(id))));
    const visibleUserList = computed(() => userList.value.filter(user => !excludeIdSet.value.has(String(user.id))));
    const loadNextPage = () => {
      if (loading.value || !hasMore.value) return;
      pagination.page += 1;
      fetchUsers({
        append: true
      });
    };
    const handleScroll = ({
      scrollTop
    }) => {
      const wrap = scrollbarRef.value?.wrapRef;
      if (!wrap) return;
      const distanceToBottom = wrap.scrollHeight - wrap.clientHeight - scrollTop;
      if (distanceToBottom <= 24) {
        loadNextPage();
      }
    };
    const handelConfirm = () => {
      if ($props.multiple) {
        value.value = userOptions.value.map(e => e.id);
      } else {
        if (userOptions.value.length > 0) {
          value.value = userOptions.value[0].id;
        } else {
          value.value = null;
        }
      }
      $emits('confirm', userOptions.value.map(u => ({
        id: u.id,
        name: u.name,
        avatar: u.avatar
      })));
      dialogVisible.value = false;
    };
    const clearSelected = () => {
      userOptions.value = [];
    };
    __expose({
      open
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_empty = _resolveComponent("el-empty");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => dialogVisible.value = $event),
        onOpen: onOpen,
        "modal-class": "user-picker-overlay",
        title: __props.multiple ? `选择用户（已选 ${userOptions.value.length}${__props.maxSelect ? '/' + __props.maxSelect : ''}）` : '选择用户',
        width: "460px",
        class: "user-picker-dialog",
        "append-to-body": "",
        "destroy-on-close": ""
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_27, [_createElementVNode("span", _hoisted_28, [__props.multiple ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_cache[6] || (_cache[6] = _createTextVNode("已选 ", -1)), _createElementVNode("em", null, _toDisplayString(userOptions.value.length), 1), _cache[7] || (_cache[7] = _createTextVNode(" 人", -1))], 64)) : userOptions.value.length === 1 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createTextVNode("已选 " + _toDisplayString(userOptions.value[0]?.name), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 2
        }, [_createTextVNode("未选择")], 64))]), _createElementVNode("div", _hoisted_29, [_createElementVNode("button", {
          type: "button",
          class: "btn-secondary",
          onClick: _cache[1] || (_cache[1] = $event => dialogVisible.value = false)
        }, "取消"), _createElementVNode("button", {
          type: "button",
          class: "btn-primary",
          onClick: handelConfirm
        }, "确认")])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [__props.multiple && userOptions.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, [_cache[3] || (_cache[3] = _createTextVNode("已选 ", -1)), _createElementVNode("em", null, _toDisplayString(userOptions.value.length), 1), _createTextVNode(_toDisplayString(__props.maxSelect ? ` / ${__props.maxSelect}` : ''), 1)]), userOptions.value.length > 0 ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "user-selected-clear",
          onClick: clearSelected
        }, "清空")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedSelectedUsers.value, user => {
          return _openBlock(), _createElementBlock("span", {
            key: user.id,
            class: "user-chip",
            title: user.name
          }, [_createElementVNode("span", _hoisted_7, [user.avatar ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: user.avatar,
            alt: user.name
          }, null, 8, _hoisted_8)) : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString((user.name || '?').charAt(0)), 1))]), _createElementVNode("span", _hoisted_10, _toDisplayString(user.name), 1), _createElementVNode("button", {
            type: "button",
            class: "user-chip-close",
            onClick: _withModifiers($event => onUserClick(user), ["stop"]),
            "aria-label": "移除"
          }, [...(_cache[4] || (_cache[4] = [_createElementVNode("svg", {
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2.5",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))], 8, _hoisted_11)], 8, _hoisted_6);
        }), 128)), hiddenSelectedUsers.value.length > 0 ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "user-chip user-chip-more",
          title: hiddenSelectedNames.value
        }, " 等 " + _toDisplayString(hiddenSelectedUsers.value.length) + " 人 ", 9, _hoisted_12)) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_13, [_createVNode(_component_el_input, {
          modelValue: queryForm.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => queryForm.name = $event),
          class: "user-search-input",
          placeholder: "搜索姓名或用户名",
          clearable: "",
          onKeyup: _withKeys(handleSearch, ["enter"]),
          onClear: handleSearch
        }, {
          prefix: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(Search))]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"]), _createElementVNode("button", {
          type: "button",
          class: "btn-primary user-search-button",
          onClick: handleSearch
        }, "查询")]), __props.multiple ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("button", {
          type: "button",
          class: "btn-text-primary user-selectall-button",
          disabled: selectAllLoading.value || loading.value || visibleUserList.value.length === 0 && !hasMore.value,
          onClick: toggleSelectAll
        }, _toDisplayString(selectAllLoading.value ? '加载中...' : isAllSelected.value ? '取消全选' : '全选'), 9, _hoisted_15), pagination.total > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_16, "共 " + _toDisplayString(pagination.total) + " 人", 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _withDirectives((_openBlock(), _createBlock(_component_el_scrollbar, {
          ref_key: "scrollbarRef",
          ref: scrollbarRef,
          tag: "div",
          class: "user-list",
          onScroll: handleScroll
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleUserList.value, user => {
            return _openBlock(), _createElementBlock("div", {
              key: user.id,
              class: _normalizeClass(["user-row", {
                'is-active': isSelected(user)
              }]),
              onClick: $event => onUserClick(user)
            }, [_createElementVNode("div", _hoisted_18, [_createElementVNode("span", {
              class: _normalizeClass(["user-avatar", {
                'has-img': user.avatar
              }])
            }, [user.avatar ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: user.avatar,
              alt: user.name
            }, null, 8, _hoisted_19)) : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString((user.name || '?').charAt(0)), 1))], 2), _createElementVNode("div", _hoisted_21, [_createElementVNode("span", _hoisted_22, _toDisplayString(user.name), 1), user.username && user.username !== user.name ? (_openBlock(), _createElementBlock("span", _hoisted_23, "@" + _toDisplayString(user.username), 1)) : _createCommentVNode("", true)])]), _createElementVNode("span", {
              class: _normalizeClass(["user-check", {
                'is-checked': isSelected(user)
              }])
            }, [isSelected(user) ? (_openBlock(), _createElementBlock("svg", _hoisted_24, [...(_cache[5] || (_cache[5] = [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "3",
              d: "M5 13l4 4L19 7"
            }, null, -1)]))])) : _createCommentVNode("", true)], 2)], 10, _hoisted_17);
          }), 128)), loading.value && userList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_25, "加载中...")) : !hasMore.value && userList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_26, "已加载全部")) : !loading.value && userList.value.length === 0 ? (_openBlock(), _createBlock(_component_el_empty, {
            key: 2,
            description: "暂无用户",
            "image-size": 64
          })) : !loading.value && userList.value.length > 0 && visibleUserList.value.length === 0 ? (_openBlock(), _createBlock(_component_el_empty, {
            key: 3,
            description: "当前列表无匹配人员",
            "image-size": 64
          })) : _createCommentVNode("", true)]),
          _: 1
        })), [[_directive_loading, loading.value && userList.value.length === 0]])])]),
        _: 1
      }, 8, ["modelValue", "title"]);
    };
  }
};